module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00089-fs8.ea59639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00089-fs8.png
// module id = 242
// module chunks = 0